import { render, staticRenderFns } from "./EditPasswordAll.vue?vue&type=template&id=104c8904&scoped=true&"
import script from "./EditPasswordAll.vue?vue&type=script&lang=js&"
export * from "./EditPasswordAll.vue?vue&type=script&lang=js&"
import style0 from "./EditPasswordAll.vue?vue&type=style&index=0&id=104c8904&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104c8904",
  null
  
)

export default component.exports